import "./index.scss";

export const ShopContent = ({
  title,
  subtitle,
  tagline,
  disclaimer,
  promocode,
  hero_bg
}) => (
  <div className="shop-content" style={{ backgroundImage: `url(${hero_bg})` }}>
    <div className="hero">
      <p className="title">{title}</p>
      <p className="subtitle">{subtitle}</p>
    </div>
    {tagline && (
      <div className="promo-code">
        <p>
          {tagline}
          <span className="bold">{promocode}</span>
          <span>{disclaimer}</span>
        </p>
      </div>
    )}
  </div>
);
